import { Button, Form, Input, Select } from 'antd';
import powerzapLogo from 'assets/logos/powerzap-kory.svg';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import './leadCapture.css';

const { Option } = Select;

const RequiredMark = () => <span className="lead-capture-required">*</span>;

export default function LeadCaptureScreen({
	form,
	language,
	options,
	countries,
	isSubmitting,
	onSubmit,
	onEmailChange,
	onWebsiteChange,
	onSelectCountry,
	onSelectObjective,
}) {
	const { getFieldDecorator } = form;
	const startConfigurationLabel = language.start_configuration || language.send;
	const title = language.lead_capture_title || language.know_you_better;
	const subtitle = language.lead_capture_subtitle || language.prioritize_your_resources;
	// Obrigatório vazio: o Figma mostra o erro no próprio campo (placeholder e borda em vermelho).
	// Com valor preenchido (erro de formato) o placeholder some, então a mensagem fica abaixo.
	const fieldClass = (name) =>
		form.getFieldError(name) && !form.getFieldValue(name)
			? 'lead-capture-field lead-capture-field-empty-error'
			: 'lead-capture-field';

	return (
		<Form onSubmit={onSubmit} id="_form_72_" className="_form _form_72 lead-capture-screen">
			<input type="hidden" name="u" value="72" />
			<input type="hidden" name="f" value="72" />
			<input type="hidden" name="s" />
			<input type="hidden" name="c" value="0" />
			<input type="hidden" name="m" value="0" />
			<input type="hidden" name="act" value="sub" />
			<input type="hidden" name="v" value="2" />

			<div className="lead-capture-brand" aria-label="PowerZap">
				<img src={powerzapLogo} alt="PowerZap" />
			</div>

			<section className="lead-capture-card" aria-labelledby="lead-capture-title">
				<header className="lead-capture-header">
					<h1 id="lead-capture-title">{title}</h1>
					<p>{subtitle}</p>
				</header>

				<div className="lead-capture-grid">
					<div className={fieldClass('fullname')}>
						<label htmlFor="fullName">
							<RequiredMark />
							{language.full_name}
						</label>
						<Form.Item>
							{getFieldDecorator('fullname', {
								rules: [
									{
										required: true,
										message: <FormattedMessage id="virtual_number_name_error_1" />,
									},
									{
										pattern: /^[a-zA-ZÀ-ÿ\s]+$/,
										message: <FormattedMessage id="virtual_number_name_error_2" />,
									},
								],
							})(
								<Input
									id="fullName"
									type="text"
									name="fullname"
									placeholder={language.input_name}
								/>,
							)}
						</Form.Item>
					</div>

					<div className={fieldClass('country')}>
						<label htmlFor="country">
							<RequiredMark />
							{language.country}
						</label>
						<Form.Item>
							{getFieldDecorator('country', {
								rules: [
									{
										required: true,
										message: language.form_trial_country_error,
									},
								],
							})(
								<Select
									showSearch
									placeholder={language.select_country_placeholder || language.country}
									onChange={onSelectCountry}
									optionFilterProp="children"
									name="field[27]"
									id="country"
								>
									{countries.map(({ name, code }) => (
										<Option key={name} value={code}>
											{name}
										</Option>
									))}
								</Select>,
							)}
						</Form.Item>
					</div>

					<div className={fieldClass('email')}>
						<label htmlFor="email">
							<RequiredMark />
							{language.email}
						</label>
						<Form.Item>
							{getFieldDecorator('email', {
								rules: [
									{
										required: true,
										message: <FormattedMessage id="virtual_number_email_error_1" />,
									},
									{
										type: 'email',
										message: <FormattedMessage id="virtual_number_email_error_2" />,
									},
								],
							})(
								<Input
									id="email"
									type="email"
									name="email"
									placeholder={language.lead_capture_email_placeholder || language.input_email}
									onChange={onEmailChange}
								/>,
							)}
						</Form.Item>
					</div>

					<div className={fieldClass('phone')}>
						<label htmlFor="phone">
							<RequiredMark />
							{language.input_phone_label}
						</label>
						<Form.Item>
							{getFieldDecorator('phone', {
								rules: [
									{
										required: true,
										message: language.form_trial_phone_error_1,
									},
									{
										pattern: /^[0-9]+$/,
										message: language.form_trial_phone_error_2,
									},
								],
							})(
								<Input
									type="text"
									name="field[16]"
									id="phone"
									placeholder={language.input_phone}
								/>,
							)}
						</Form.Item>
					</div>

					<div className="lead-capture-field">
						<label htmlFor="website">
							{language.lead_capture_website_label || language.enterprise_website}
						</label>
						<Form.Item>
							{getFieldDecorator('website')(
								<Input
									type="text"
									name="website"
									id="website"
									placeholder={language.lead_capture_website_placeholder || language.input_website}
									onChange={onWebsiteChange}
								/>,
							)}
						</Form.Item>
					</div>

					<div className={fieldClass('objective')}>
						<label htmlFor="objective">
							<RequiredMark />
							{language.lead_capture_objective_label || language.objective_with_the_application}
						</label>
						<Form.Item>
							{getFieldDecorator('objective', {
								rules: [
									{
										required: true,
										message: language.form_trial_objective_error,
									},
								],
							})(
								<Select
									onChange={onSelectObjective}
									placeholder={language.select_objective}
									id="objective"
								>
									{options.map((option) => (
										<Option key={option.label} value={option.value}>
											{option.label}
										</Option>
									))}
								</Select>,
							)}
						</Form.Item>
					</div>
				</div>

				<div className="lead-capture-actions">
					<Button
						id="_form_72_submit"
						size="large"
						type="primary"
						className="lead-capture-submit"
						htmlType="submit"
						loading={isSubmitting}
					>
						{isSubmitting ? language.btn_loading_trial : startConfigurationLabel}
					</Button>
				</div>
			</section>
		</Form>
	);
}
